export enum Seniority {
  EntryLevel = 0,
  MidManagement = 1,
  SeniorManagement = 2,
}

export enum SeniorityDescription {
  EntryLevel = 'Entry level',
  MidManagement = 'Mid management',
  SeniorManagement = 'Senior management',
}
